import { render, staticRenderFns } from "./SurveyQuestion.vue?vue&type=template&id=d8812c68&scoped=true&"
import script from "./SurveyQuestion.vue?vue&type=script&lang=js&"
export * from "./SurveyQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SurveyQuestion.vue?vue&type=style&index=0&id=d8812c68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8812c68",
  null
  
)

export default component.exports